import React from "react";
import { Reveal, Section, Container, EyebrowLarge } from "./Shared";

export default function WhyIvani() {
    return (
        <Section id="why" className="relative font-body py-24 md:py-32">
            {/* Background Ambience */}
            <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full blur-[120px] pointer-events-none opacity-[0.1]" style={{ background: 'var(--ivani-color)' }} />

            <Container>
                <EyebrowLarge className="mb-10 md:mb-16 text-center">WHY IVANI?</EyebrowLarge>

                <div className="grid gap-6 lg:grid-cols-2 items-stretch">
                    <Reveal className="h-full">
                        <div className="h-full glass-card p-8 md:p-12 rounded-[40px] border border-white/10 relative overflow-hidden group hover:border-white/20 transition-all duration-500">
                            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <h4 className="relative z-10 font-heading text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
                                Outcome‑first, <br />
                                <span className="text-zinc-500">not directory‑first.</span>
                            </h4>
                            <p className="relative z-10 mt-6 text-zinc-400 text-lg md:text-xl leading-relaxed font-light">
                                Every organization, at some point, hits a roadblock — a
                                missing piece that holds back its next leap of growth. It
                                might be the right idea, the right talent, the right partner,
                                or simply the right direction.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal className="h-full">
                        <div className="h-full glass-card p-8 md:p-12 rounded-[40px] border border-white/10 relative overflow-hidden group hover:border-white/20 transition-all duration-500 bg-white/5">
                            <div className="absolute inset-0 bg-gradient-to-bl from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <h4 className="relative z-10 font-heading text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
                                At IVANI, we exist to <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-zinc-400">bridge that gap.</span>
                            </h4>

                            <div className="relative z-10 space-y-6">
                                <p className="text-zinc-300 text-lg md:text-xl leading-relaxed">
                                    We listen, we connect, and we align — helping organizations find exactly what they need to move forward.
                                </p>

                                <div className="h-px w-full bg-white/10"></div>

                                <p className="text-zinc-400 text-base md:text-lg italic font-light">
                                    "Because when the right connections happen, ideas grow stronger, people grow faster, and businesses become unstoppable."
                                </p>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </Container>
        </Section>
    );
}
